import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-json-viewer',
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss']
})
export class JsonViewerComponent implements OnInit {

  title: string;
  formattedJson: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private jsonPipe: JsonPipe,
  ) {
    this.title = data.title;
  }

  ngOnInit(): void {
    this.formattedJson = this.jsonPipe.transform(this.data.data);
  }
}
